export const SHOW_MORE_LIMIT = 3
